"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareReferalApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var ShareReferalApi = /** @class */ (function () {
    function ShareReferalApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 获取上线账号
     * @method GET 获取上线账号
     *
     */
    ShareReferalApi.prototype.upper = function () {
        return this.http
            .url("/api/ShareReferal/upper")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 获取下线账号
     * @method GET 获取下线账号
     *
     */
    ShareReferalApi.prototype.lower = function () {
        return this.http
            .url("/api/ShareReferal/lower")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 修改指定账号所属上级
     * @method PUT 修改指定账号所属上级
     *
     * @params accountId 账号Id
     */
    ShareReferalApi.prototype.putUpper = function (accountId) {
        return this.http
            .url("/api/ShareReferal/" + accountId + "/upper")
            .addSecurityHeaders()
            .support('PUT');
    };
    ShareReferalApi.diOptions = di_1.default.options({
        name: "ShareReferalApi",
        scope: "Singleton"
    });
    return ShareReferalApi;
}());
exports.ShareReferalApi = ShareReferalApi;
exports.default = ShareReferalApi;
